module.exports = __webpack_public_path__ + "img/icon_lvjing_rixi_hover@2x.e091db7b.png";